export default {
    id: null,
    name : "",
    address1 : "",
    address2 : "",
    city : "",
    phone : "",
    workshop_id : ""
}